/* eslint-disable react/prop-types */
// eslint-disable-next-line no-unused-vars
import React, { useContext, useRef } from "react";
import { updateCallback } from "../../../hooks/update-hooks/update-callbacks/update-callback";
import { CallBackContext } from "../../../contexts";
import { debounce } from "lodash";
import { toast } from "react-toastify";

function OrderValueModal({ callback }) {
    const { refetch } = useContext(CallBackContext)

    // eslint-disable-next-line no-unused-vars
    const orderValueRef = useRef()
    const updateOrderValue = async (value) => {
        try {
            await updateCallback({ 'additionalDetails': { ...callback.additionalDetails, orderValue: value } }, callback.id)
            refetch();
        } catch (error) {
            toast.error(error)
        }
    }
    const debounceOnChange = React.useCallback(debounce(updateOrderValue, 200), []);

    return <React.Fragment>
        <input type="text" ref={orderValueRef} className="border border-gray-200 text-left w-[80px] rounded-md p-2 focus:outline-none" onChange={(e) => debounceOnChange(e.target.value)} defaultValue={callback.additionalDetails?.orderValue} />
    </React.Fragment >
}

export { OrderValueModal };